export default {
  stepHeaderFontSizeSmall: '14px',
  stepHeaderFontSizeMedium: '16px',
  indicatorIndexFontSizeSmall: '14px',
  indicatorIndexFontSizeMedium: '16px',
  indicatorSizeSmall: '22px',
  indicatorSizeMedium: '28px',
  indicatorIconSizeSmall: '14px',
  indicatorIconSizeMedium: '18px'
};